import * as React from 'react';
import classNames from 'classnames';
import DatePanel from '../DatePanel';
import TimePanel from '../TimePanel';
import { tuple } from '../../utils/miscUtil';
import { setDateTime as setTime } from '../../utils/timeUtil';
const ACTIVE_PANEL = tuple('date', 'time');
function DatetimePanel(props) {
    const { prefixCls, generateConfig, value, defaultValue, disabledTime, showTime, onSelect, } = props;
    const panelPrefixCls = `${prefixCls}-datetime-panel`;
    // @ts-ignore
    const [activePanel, setActivePanel] = React.useState(null);
    const dateOperationRef = React.useRef({});
    const timeOperationRef = React.useRef({});
    const timeProps = typeof showTime === 'object' ? Object.assign({}, showTime) : {};
    // ======================== Events ========================
    const onInternalSelect = (date, source) => {
        let selectedDate = date;
        if (source === 'date' && !value && timeProps.defaultValue) {
            // Date with time defaultValue
            selectedDate = generateConfig.setHour(selectedDate, generateConfig.getHour(timeProps.defaultValue));
            selectedDate = generateConfig.setMinute(selectedDate, generateConfig.getMinute(timeProps.defaultValue));
            selectedDate = generateConfig.setSecond(selectedDate, generateConfig.getSecond(timeProps.defaultValue));
        }
        else if (source === 'time' && !value && defaultValue) {
            selectedDate = generateConfig.setYear(selectedDate, generateConfig.getYear(defaultValue));
            selectedDate = generateConfig.setMonth(selectedDate, generateConfig.getMonth(defaultValue));
            selectedDate = generateConfig.setDate(selectedDate, generateConfig.getDate(defaultValue));
        }
        if (onSelect) {
            onSelect(selectedDate, 'mouse');
        }
    };
    // ======================== Render ========================
    const disabledTimes = disabledTime ? disabledTime(value || null) : {};
    return (<div className={classNames(panelPrefixCls, {
            [`${panelPrefixCls}-active`]: activePanel,
        })}>
            <DatePanel {...props} operationRef={dateOperationRef} active={activePanel === 'date'} onSelect={date => {
            onInternalSelect(setTime(generateConfig, date, showTime && typeof showTime === 'object'
                ? showTime.defaultValue
                : null), 'date');
        }}/>
            <TimePanel {...props} format={undefined} {...timeProps} {...disabledTimes} defaultValue={undefined} operationRef={timeOperationRef} active={activePanel === 'time'} onSelect={date => {
            onInternalSelect(date, 'time');
        }}/>
        </div>);
}
export default DatetimePanel;
